export const en = {
  search: 'Search...',
  cancel: 'Cancel',
  connecting: 'Sending task. This may take a moment to sync.'
};

export type Translations = typeof en;
